import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { history, strings } from "../../helpers";
import { loginConstants } from "./loginConstants";
import { postLogin } from "../../services";

/**
 * @function setUserDetails
 * @param responseObj
 * @desc This function sets the user related info in localStorage, upon signing in
 */
export const setUserDetails = (responseObj, dispatch) => {
  // Set user data
  const adminAccount = responseObj.data.user.user_accounts.filter(ua => {
    return ua.account_type === "super_admin";
  });

  const customerCareAccount = responseObj.data.user.user_accounts.filter(ua => {
    return ua.account_type === "customer_care";
  });

  const billingAccountAccount = responseObj.data.user.user_accounts.filter(
    ua => {
      return ua.account_type === "billing_admin";
    }
  );

  if (adminAccount.length > 0) {
    localStorage.setItem("account_type", "super_admin");
  } else if (
    adminAccount.length === 0 &&
    customerCareAccount.length > 0 &&
    billingAccountAccount.length === 0
  ) {
    localStorage.setItem("account_type", "customer_care");
  } else if (
    adminAccount.length === 0 &&
    customerCareAccount.length === 0 &&
    billingAccountAccount.length > 0
  ) {
    localStorage.setItem("account_type", "billing_admin");
  }

  localStorage.setItem("authToken", `Bearer ${responseObj.auth_token}`);
  localStorage.setItem("idt", `${responseObj.refresh_token}`);
  localStorage.setItem("user", JSON.stringify(responseObj.data.user));
  dispatch(userLoggedIn(true));
  dispatch(loginSuccess(responseObj.data.user));

  history.push("/clinics");
};

export const loginProcessing = isProcessing => {
  return { type: loginConstants.LOGIN_PROCESSING, isProcessing };
};
export const loginSuccess = user => {
  return { type: loginConstants.LOGIN_SUCCESS, user };
};
export const loginFailure = error => {
  return { type: loginConstants.LOGIN_FAILURE, error };
};
export const userLoggedIn = user_logged_in => {
  return { type: loginConstants.USER_LOGGED_IN, user_logged_in };
};

/**
 * @function loginAction
 * @param phoneNumber
 * @param password
 * @desc This logins the user.
 */
export const loginAction = (phoneNumber, password) => {
  return dispatch => {
    dispatch(loginProcessing(true));
    postLogin(phoneNumber, password).then(response => {
      // login successful
      dispatch(loginProcessing(false));
      if (response.data && response.data.data && response.data.data.user) {
        const responseObj = response.data;

        const adminAccount = responseObj.data.user.user_accounts.filter(ua => {
          return (
            ua.account_type === "super_admin" ||
            ua.account_type === "customer_care" ||
            ua.account_type === "billing_admin"
          );
        });
        if (adminAccount.length > 0) {
          setUserDetails(responseObj, dispatch);
          const role = localStorage.getItem("account_type");

          if (process.env.REACT_APP_ENVIRONMENT === "production") {
            Sentry.configureScope(scope => {
              scope.setTag("username", role);
              scope.setUser({
                id: responseObj.data.user.id,
                username: role,
                phoneNumber: responseObj.data.user.phone_number
              });
            });
          }

          // dispatch userLoggedIn method, to update the Top nav
        } else {
          const errorList = {
            source: "username_or_password"
          };
          dispatch(loginFailure(errorList));
          dispatch(userLoggedIn(false));
        }
      } else if (response.data && response.data.errors) {
        const errorList = response.data.errors;
        dispatch(loginFailure(errorList));
        dispatch(userLoggedIn(false));
      }
    });
  };
};

export const resetReducers = () => {
  return { type: "RESET_REDUCERS" };
};

/**
 * @function logoutAction
 * @param dispatch
 * @desc This function logout the user.
 */
export const logoutAction = dispatch => {
  dispatch(loginProcessing(true));

  localStorage.clear();
  dispatch(loginProcessing(false));
  dispatch(userLoggedIn(false));
  dispatch(resetReducers()); // clear store
  Sentry.configureScope(scope => scope.clear());
  history.push("/");
};
